/* Filet de securite panier — Claude.
   Ecoute posee sur document (phase capture) : survit a une reecriture du <body>.
   1. Reactive toujours le champ 'id' que le theme laisse disabled dans le HTML.
   2. Si le panier du theme est mort, prend la main : ajout + redirection panier.
   3. Si le panier du theme repond present, le laisse faire MAIS surveille :
      si le tiroir ne s'ouvre pas en 2,5 s, redirige vers la page panier. */
(function () {
  'use strict';

  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var CART_ADD = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var WATCHDOG_MS = 2500;

  function upgraded(el) {
    if (!el || typeof customElements === 'undefined') return false;
    var Ctor = customElements.get(el.tagName.toLowerCase());
    return !!Ctor && el instanceof Ctor;
  }

  function themeCartWorks() {
    var pf = document.querySelector('product-form');
    if (!upgraded(pf)) return false;
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!upgraded(drawer)) return false;
    return typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
  }

  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    var type = form.getAttribute('data-type') || '';
    return action.indexOf('/cart/add') !== -1 || type === 'add-to-cart-form';
  }

  /* Le theme rend <input name="id" ... disabled>. Sans ca, le panier part vide. */
  function enableVariantInput(form) {
    var inputs = form.querySelectorAll('[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].disabled) inputs[i].disabled = false;
    }
  }

  function busy(form, on) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
    else { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); }
  }

  function drawerIsOpen() {
    return !!document.querySelector('cart-drawer.active, cart-notification.active, cart-drawer.animate.active');
  }

  function addToCart(form) {
    enableVariantInput(form);
    busy(form, true);
    fetch(CART_ADD + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          busy(form, false);
          alert(res.body.description || res.body.message || 'Ce produit ne peut pas etre ajoute au panier.');
          return;
        }
        window.location.href = CART_URL;
      })
      .catch(function () { window.location.href = CART_URL; });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isAddForm(form)) return;

      enableVariantInput(form);

      if (!themeCartWorks()) {
        e.preventDefault();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        console.warn('[cart-fallback] panier du theme inactif : ajout direct puis redirection.');
        addToCart(form);
        return;
      }

      console.info('[cart-fallback] panier du theme actif : surveillance ' + WATCHDOG_MS + ' ms.');
      setTimeout(function () {
        if (drawerIsOpen()) return;
        console.warn('[cart-fallback] le tiroir ne s est pas ouvert : redirection panier.');
        window.location.href = CART_URL;
      }, WATCHDOG_MS);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var link = t.closest('#cart-icon-bubble, a[href$="/cart"]');
      if (!link) return;
      if (themeCartWorks()) return;
      e.preventDefault();
      window.location.href = CART_URL;
    },
    true
  );

  /* Le champ 'id' est reactive des que possible, meme sans clic. */
  function primeForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (isAddForm(forms[i])) enableVariantInput(forms[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeForms);
  } else {
    primeForms();
  }
  window.addEventListener('load', primeForms);
  setTimeout(primeForms, 1500);
})();
